<div class="wrapper">
  <div *ngIf="!vars?.selected_partner" class="head">
    <div class="title">{{config?.title || 'Monthly Giving'}}</div>
    <div class="logo">
      <img class="child-sip-banner-bg" src="/assets/images/assured.png" alt="" srcset="">
    </div>
  </div>

  <div *ngIf="vars?.selected_partner?.name" class="partner-pay">
    <div class="title partner">Plan selected: {{vars?.selected_partner?.plan | titlecase}}</div>
  </div>
  <div *ngIf="vars?.selected_partner?.name && qparam?.plan !== 'plus'" class="partner-pay">
    <app-module-loader [load]="true" moduleId="partner-plan-upgrade-nudge" selector="app-partner-plan-upgrade-nudge"></app-module-loader>
  </div>

  <div class="desc">
    <div class="amount-section">
      <div *ngIf="!vars?.selected_partner?.name" class="info">Amount selected</div>
      <div *ngIf="vars?.selected_partner?.name" class="info">Autopay of</div>
      <div *ngIf="config?.frequency_term !== 'days'" class="amount" [ngClass]="{'mb-0': vars?.selected_partner}">
        <app-currency-icon [currency]="config?.currency"></app-currency-icon>{{config?.amount}}<span *ngIf="config?.tenure" class="month">(for {{config?.tenure}} months)</span><span *ngIf="!config?.tenure" class="month">{{config?.month_interval>1 ? '/ '+config?.month_interval+' months' : '/month'}}</span>
      </div>
      <div *ngIf="config?.frequency_term === 'days'" class="amount">
        <app-currency-icon [currency]="config?.currency"></app-currency-icon>{{config?.amount}}<span class="month">{{config?.frequency>1 ? '/ '+config?.frequency+' days' : '/day'}}</span>
      </div>
    </div>
    <div *ngIf="config?.warning_text && !qparam?.utm_source?.match('external_impact_calling') && !vars?.selected_partner" class="note">
      <div *ngIf="!config?.hide_Warning_icon" class="icon"><span class="material-icons">error</span></div>
      <div class="text" [innerHtml]="config?.warning_text"></div>
    </div>
    <div *ngIf="config?.warning_text && qparam?.utm_source?.match('external_impact_calling') && !vars?.selected_partner" class="note1">
      <div *ngIf="!config?.hide_Warning_icon" class="icon"><span class="material-icons">support_agent</span></div>
      <div class="text"><strong>Hi {{user?.full_name?.trim() | titlecase}},</strong> You just connected with {{qparam?.utm_medium?.replace('calling_', '')?.replaceAll('+', ' ') | titlecase}}. Please complete your payment.</div>
    </div>
  </div>
</div>
